import { render, staticRenderFns } from "./asl.vue?vue&type=template&id=73b3700b&scoped=true"
import script from "./asl.vue?vue&type=script&lang=js"
export * from "./asl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b3700b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73b3700b')) {
      api.createRecord('73b3700b', component.options)
    } else {
      api.reload('73b3700b', component.options)
    }
    module.hot.accept("./asl.vue?vue&type=template&id=73b3700b&scoped=true", function () {
      api.rerender('73b3700b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/RMC/Protein/rmcPurchaseQty/asl.vue"
export default component.exports